<dvm-notice [dvmUnaryAttribute]="type" [title]="title">
  {{ message }}
</dvm-notice>